var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9584 11.5308L10.9749 7.90812C10.792 7.77554 10.5492 7.75557 10.3487 7.8586C10.1467 7.96083 10.0205 8.16847 10.0205 8.39289V15.6358C10.0205 15.8626 10.1467 16.0694 10.3487 16.1717C10.4342 16.2148 10.5276 16.2364 10.6219 16.2364C10.7449 16.2364 10.8695 16.1972 10.9749 16.1198L15.9584 12.5003C16.1157 12.3845 16.2076 12.2056 16.2076 12.0155C16.2084 11.8223 16.1141 11.6442 15.9584 11.5308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 0.00158691C5.37167 0.00158691 0 5.37325 0 12.002C0 18.6283 5.37167 23.9984 12.0004 23.9984C18.6275 23.9984 24 18.6275 24 12.002C24.0008 5.37325 18.6275 0.00158691 12.0004 0.00158691ZM12.0004 21.9962C6.48018 21.9962 2.00459 17.523 2.00459 12.002C2.00459 6.48337 6.48018 2.00458 12.0004 2.00458C17.5198 2.00458 21.9946 6.48257 21.9946 12.002C21.9954 17.523 17.5198 21.9962 12.0004 21.9962Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayWhite);
export default __webpack_public_path__ + "static/media/icon-play-white.0710a3e0450dffed08b7b0f3ad6c5b96.svg";
export { ForwardRef as ReactComponent };